import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import img5 from '../images/shutterstock_1039074919.webp'
import sha256 from 'crypto-js/sha256';
import { useTranslation } from 'react-i18next';
import Cropper from 'react-easy-crop';


function ServicesEdit({ dragHandleProps }) {

  const { t } = useTranslation();

  const apiUrl = process.env.REACT_APP_BACKEND_URL

  let ImageUrl = process.env.REACT_APP_IMAGES_URL
  const [Imagecontent, setImagecontent] = useState('')
  let LanguageSelected = Cookies.get('LanguageSelected');


  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');

  const hashedUserId = sha256((String(userId)));

  const [FindServiceModal, setFindServiceModal] = useState(false)
  const [FindServiceInfo, setFindServiceInfo] = useState(false)

  const [ServicesModal, setServicesModal] = useState(false)
  const [EditServicesModal, setEditServicesModal] = useState(false)

  const [InputsErrors, setInputsErrors] = useState([])

  const [serviceInfo, setServiceInfo] = useState({
  name: { fr: '', en: '', ar: '' },
  description: { fr: '', en: '', ar: '' },
  link: '',
  Price: '',
  currency: 'MAD',
  Image: ''
})
  const [Done, setDone] = useState(false)

  const [serviceId, setServiceId] = useState()
  const [serviceContent, setServiceContent] = useState([])
  const [isFetching, setIsFetching] = useState(false);

  const [editImage, seteditImage] = useState(false)

  const [activeIndex, setActiveIndex] = useState(0)

  const goToPrev = () => {
    setActiveIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : serviceContent.length - 1));
  };

  const goToNext = () => {
    setActiveIndex((prevIndex) => (prevIndex < serviceContent.length - 1 ? prevIndex + 1 : 0));
  };

  // const AddingserviceInfo = (e) => {
  //   return setServiceInfo({ ...serviceInfo, [e.target.name]: e.target.value })

  // }

const AddingserviceInfo = (e) => {
  const { name, value } = e.target;
  
  if (name.includes('-')) {
    const [field, lang] = name.split('-');
    setServiceInfo(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [lang]: value
      }
    }));
  } else {
    setServiceInfo(prev => ({ ...prev, [name]: value }));
  }
}

  function compressImage(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 800; // Set your desired max width
          const maxHeight = 600; // Set your desired max height
          let newWidth = img.width;
          let newHeight = img.height;

          if (img.width > maxWidth || img.height > maxHeight) {
            const aspectRatio = img.width / img.height;
            if (aspectRatio > 1) {
              newWidth = maxWidth;
              newHeight = maxWidth / aspectRatio;
            } else {
              newHeight = maxHeight;
              newWidth = maxHeight * aspectRatio;
            }
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type, 0.7); // Adjust compression quality here (0.7 = 70%)
        };
      };
      reader.readAsDataURL(file);
    });
  }

  const AddingserviceInfoImage = async (e) => {
    let Picture = e.target.files[0]
    if (!Picture) {
      toast.error('No image selected');
      return;
    }

    const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];
    const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

    const extension = Picture.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      toast.error('Invalid image format. Allowed formats: PNG, JPG, JPEG, GIF');
      return;
    }

    if (Picture.size > maxSize) {
      toast.error('Image size exceeds 20 MB');
      return;
    }

    handleImageCrop(e, Picture)
  };




  const SetServiceToUpdateDefaultValues = (id) => {
    const service = serviceContent.find(service => service.id == id)
    return setServiceInfo(
      { ...serviceInfo, 
        serviceId: id, 
        currency: service.currency || 'MAD', 
        price: service.price || '', 
        name: service.name || {fr:'',en:'',ar:''}, 
        link: service.link, 
        description: service.description || {fr:'',en:'',ar:''},
        Image: ''
      })

  }

  useEffect(() => {
    fetch(`${apiUrl}/GetServiceInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setServiceContent(result.data)

        }
      })
  }, [Done])

  const StoreServiceInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()
    axios
      .post(`${apiUrl}/StoreServiceInfo`, serviceInfo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setServiceInfo('')
          setDone(!Done)
          setCropImage(false)
          setInputsErrors([])
          setZoom(1)

          setImageToCrop(null)
          setCroppedImage(null)
          setImagecontent('')
          setServicesModal(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });


  }
  const UpdateServiceInfo = (e) => {
    setIsFetching(true);

    e.preventDefault()

    axios
      .post(`${apiUrl}/UpdateServiceInfo`, serviceInfo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setServiceInfo('')
          setCropImage(false)
          setInputsErrors([])
          setImageToCrop(null)
          setCroppedImage(null)
          setZoom(1)

          setDone(!Done)
          seteditImage(false)
          setEditServicesModal(false)
          setImagecontent('')
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }
const DeleteServiceInfo = (e, id, lang) => {
  e.preventDefault();
  
  console.log('Deleting service:', { id, lang }); // Debug log

  fetch(`${apiUrl}/DeleteServiceInfo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${UserToken}`
    },
    body: JSON.stringify({ serviceId: id, lang: lang })
  })
    .then(response => {
      console.log('Response status:', response.status); // Debug log
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(result => {
      console.log('Delete result:', result); // Debug log
      
      if (result.success) {
        // Option 1: Reload data from server (safest)
        setDone(!Done); // This will trigger useEffect to reload all services
        
        // Option 2: Update local state (faster but needs to match backend exactly)
        // const newServiceContent = serviceContent.map(s => {
        //   if (s.id === id) {
        //     return {
        //       ...s,
        //       name: { ...s.name, [lang]: '' },
        //       description: { ...s.description, [lang]: '' }
        //     };
        //   }
        //   return s;
        // });
        // setServiceContent(newServiceContent);
        
        toast.success(result.message, { position: toast.POSITION.CENTER });
      } else {
        toast.error(result.message || 'Delete failed');
      }
    })
    .catch(error => {
      console.error('Delete error:', error);
      toast.error('Error deleting service: ' + error.message);
    });
}
  // const DeleteServiceInfo = (e, id,lang) => {
  //   e.preventDefault()

  //   fetch(`${apiUrl}/DeleteServiceInfo`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       'Authorization': `Bearer ${UserToken}`

  //     },
  //     body: JSON.stringify({ serviceId: id,lang:lang })
  //   })
  //     .then(response => response.json())
  //     .then(result => {
  //       if (result.success) {
  //         const newServiceContent = serviceContent.map(s=>{
  //           if(s.id === id){
  //             return{
  //               ...s,
  //               name: { ...s.name, [lang]: '' },
  //               description:{...s.description,[lang]:''}
  //             };
  //           }
  //           return s;
  //         });
  //         setServiceContent(newServiceContent);
  //         toast.success(result.message,{position:toast.POSITION.CENTER});

  //       }
  //     })
  // }
// const DeleteServiceInfo = (e, id, lang) => {
//   e.preventDefault();

//   fetch(`${apiUrl}/DeleteServiceInfo`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       'Authorization': `Bearer ${UserToken}`
//     },
//     body: JSON.stringify({ serviceId: id, lang: lang })
//   })
//     .then(response => response.json())
//     .then(result => {
//       if (result.success) {
//         // Update local state to reflect the deletion
//         const newServiceContent = serviceContent.map(s => {
//           if (s.id === id) { // ✅ Compare with id, not lang
//             return {
//               ...s,
//               name: { ...s.name, [lang]: '' },
//               description: { ...s.description, [lang]: '' }
//             };
//           }
//           return s;
//         });
//         setServiceContent(newServiceContent);
//         toast.success(result.message, { position: toast.POSITION.CENTER });
//       }
//     })
//     .catch(error => {
//       console.error('Delete error:', error);
//       toast.error('Error deleting service');
//     });
// }

  const [CropImage, setCropImage] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });


  useEffect(() => {
    if (FindServiceModal || EditServicesModal || ServicesModal || CropImage) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [FindServiceModal, ServicesModal, EditServicesModal, CropImage]);



  const [imageToCrop, setImageToCrop] = useState(null);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };



  const handleImageCrop = (e, fileImage) => {
    const file = fileImage;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // Set state to control UI, like showing cropped image or closing modal

    setCropImage(true);
  };
  const Base64Image = async () => {
    const croppedImageBase64 = await convertBlobToBase64(croppedImage);
    return setServiceInfo({ ...serviceInfo, Image: croppedImageBase64 }); // Assuming LinksInfo is your state object


  }


  const handleCropComplete = async (_, croppedAreaPixels) => {
    try {
      const croppedImageBlob = await getCroppedImageBlob(imageToCrop, croppedAreaPixels);
      const compressedFile = await compressImage(croppedImageBlob);
      setCroppedImage(compressedFile);
    } catch (error) {
      console.error('Error cropping image:', error);
    }
  };
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  };


  const getCroppedImageBlob = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      const canvas = document.createElement('canvas');
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext('2d');

      image.onload = () => {
        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg');
      };
    });
  };


  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
      <div className="  sections rounded-xl pt-3 pb-3 pl-3 pr-3 m-3 ">

        <div className="pb-2">
          <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-1.5' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t("Produits et services")}</h1>
        </div>

        <div className="row relative">
          {serviceContent != '' &&
            <>

              <a
                className=" cursor-pointer text-semibold hover:text-gray-500 -right-4  absolute top-12"
                onClick={goToNext}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer  text-gray-300">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </a>
              <a
                className="text-gray-300 cursor-pointer hover:text-gray-500 -left-4 absolute  top-12"
                onClick={goToPrev}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer text-gray-300">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
              </a> </>
          }
          <div className="absolute top-40 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">
            {serviceContent.map((_, i) => (
              <span
                key={i}
                className={`block h-1  cursor-pointer rounded-2xl transition-all  ${activeIndex === i ? "bg-gray-300 w-8" : "bg-gray-300 w-4"}`}
                onClick={() => setActiveIndex(i)}
              />
            ))}
          </div>
          {/* Case Item */}
          {/* {serviceContent != '' &&
            serviceContent.map((service, index) => {
              return (
                <>
                  <div className={` relative ${activeIndex === index ? "" : "hidden"}`}
                    key={service.id}>

                    <div className="p-3 rounded-xl m-2 div-sections" >
                      <div className='grid grid-cols-5 gap-4 items-center flex justify-center'>
                        <div className='col-span-2 flex items-center justify-center'>
                          <img className=" h-28 w-28 rounded-xl" alt src={service.image !== null ? `${ImageUrl}/${hashedUserId}/${service.image}` : img5} />
                        </div>

                        <div className='col-span-3 flex flex-wrap justify-start items-center '>
                          <h3 className={`title text-start leading-none title--h5 ${LanguageSelected == 'ar' ? 'ml-6' : 'mr-6'}`} 
                          style={{ display: '-webkit-box', overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                            {service.name?.[LanguageSelected] || service.name?.fr || service.name?.en || ''}
                          </h3>
                          <div className="w-64 mt-1 text-theme case-item__caption text-about " style={{ display: '-webkit-box', overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                              {service.description?.[LanguageSelected] || service.description?.fr || service.description?.en || ''}
                          </div>

                          <div className='flex items-center justify-start gap-2 mt-2'>
                            {service.link != null &&
                              <a target='_blank' href={service.link} className='text-gold font-bold ' >
                                {t("Voir")} </a>

                            }


                            <a onClick={() => { setFindServiceInfo(service.id); setFindServiceModal(true) }} className='text-gold font-bold' >
                              {t("Details")} </a>

                          </div>

                        </div>
                      </div>
                      <div className={`${LanguageSelected == 'ar' ? 'absolute left-4 bottom-3  flex items-center justify-center' : 'absolute -right-2 bottom-3  flex items-center justify-center'}`}>
                        <svg onClick={() => { setEditServicesModal(true); setServiceId(service.id); SetServiceToUpdateDefaultValues(service.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                        </svg>
                        <svg onClick={(e) => { DeleteServiceInfo(e, service.id,LanguageSelected) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5' : 'w-6 mr-5'}`}>
                          <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                      </div>
                    </div>

                  </div>
                </>


              )
            })
          } */}
{serviceContent != '' &&
  serviceContent.map((service, index) => {
    const currentName = service.name?.[LanguageSelected] || '';
    const currentDesc = service.description?.[LanguageSelected] || '';
    const isEmpty = !currentName.trim() && !currentDesc.trim();
    
    return (
      <div className={`relative ${activeIndex === index ? "" : "hidden"}`} key={service.id}>
        <div className="p-3 rounded-xl m-2 div-sections">
          {isEmpty ? (
            // Empty state - show placeholder
            <div className="col-span-2 flex items-center justify-center">
              <img 
                  className="h-28 w-28 rounded-xl" 
                  alt="" 
                  src={service.image !== null ? `${ImageUrl}/${hashedUserId}/${service.image}` : img5} 
                />
              {/* <svg 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth="1.5" 
                stroke="currentColor" 
                className="w-12 h-12 mx-auto text-gray-400 mb-3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg> */}
              <p className="text-gray-400 m-3">
                {t("No translation available for")} {LanguageSelected.toUpperCase()}
              </p>
              <button
                onClick={() => {
                  setEditServicesModal(true);
                  setServiceId(service.id);
                  SetServiceToUpdateDefaultValues(service.id);
                }}
                className="text-gold hover:underline font-semibold">
                {t("Add translation")} →
              </button>
            </div>
          ) : (
            // Normal display with content
            <div className='grid grid-cols-5 gap-4 items-center flex justify-center'>
              <div className='col-span-2 flex items-center justify-center'>
                <img 
                  className="h-28 w-28 rounded-xl" 
                  alt="" 
                  src={service.image !== null ? `${ImageUrl}/${hashedUserId}/${service.image}` : img5} 
                />
              </div>

              <div className='col-span-3 flex flex-wrap justify-start items-center'>
                <h3 
                  className={`title text-start leading-none title--h5 ${LanguageSelected == 'ar' ? 'ml-6' : 'mr-6'}`} 
                  style={{ display: '-webkit-box', overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                  {currentName || service.name?.fr || service.name?.en || t('Untitled')}
                </h3>
                
                <div 
                  className="w-64 mt-1 text-theme case-item__caption text-about" 
                  style={{ display: '-webkit-box', overflow: 'hidden', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                  {currentDesc || service.description?.fr || service.description?.en || ''}
                </div>

                <div className='flex items-center justify-start gap-2 mt-2'>
                  {service.link != null &&
                    <a target='_blank' href={service.link} className='text-gold font-bold'>
                      {t("Voir")}
                    </a>
                  }
                  <a 
                    onClick={() => { 
                      setFindServiceInfo(service.id); 
                      setFindServiceModal(true) 
                    }} 
                    className='text-gold font-bold cursor-pointer'>
                    {t("Details")}
                  </a>
                </div>
              </div>
            </div>
          )}
          
          {/* Edit and Delete buttons - always show */}
          <div className={`${LanguageSelected == 'ar' ? 'absolute left-4 bottom-3 flex items-center justify-center' : 'absolute -right-2 bottom-3 flex items-center justify-center'}`}>
            <svg 
              onClick={() => { 
                setEditServicesModal(true); 
                setServiceId(service.id); 
                SetServiceToUpdateDefaultValues(service.id) 
              }} 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              strokeWidth="1.5" 
              stroke="currentColor" 
              className="w-6 cursor-pointer hover:text-blue-500">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
            </svg>
            
            {!isEmpty && ( // Only show delete if there's content to delete
              <svg 
                onClick={(e) => { DeleteServiceInfo(e, service.id, LanguageSelected) }} 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                strokeWidth="1.5" 
                stroke="currentColor" 
                className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5' : 'w-6 mr-5'} cursor-pointer hover:text-red-500`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
            )}
          </div>
        </div>
      </div>
    );
  })
}
          <a onClick={() => { setServicesModal(true) }}>

            <main className="flex p-5  items-center justify-center  mt-10">
              <label htmlFor="dropzone-file-inputservice" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections p-6 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="mt-2 text-about tracking-wide">{t("Entrez vos informations sur les produits ou services.")} </p>
              </label></main></a>
          <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
              <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
            </svg>

          </div>
        </div>
      </div>




      {ServicesModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed overflow-auto  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setServicesModal(false); setImageToCrop(null); setCroppedImage(null); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2 mt-22">{t("Produits et services")}
              </h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="image" className="textModal ">{t("Mettez en avant vos produits et services et listez toutes les plateformes où vos réunions peuvent les obtenir")}</label>
                  {croppedImage &&
                    <div className='relative '>
                      <div className='w-44 h-44'>
                        <img className="cover w-full h-full preview-image  border rounded-xl mt-4" src={URL.createObjectURL(croppedImage)} alt="Preview" />

                      </div>
                      <a onClick={() => { setImageToCrop(null); setCroppedImage(null) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1  text-white div-sections opacity-50 rounded-xl  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                        </svg>
                      </a>
                      <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>

                    </div>

                  }

                  <div className="flex items-center justify-center w-full">
                    {!croppedImage &&
                      <label htmlFor="dropzone-file-service" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections  ">

                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                            </path>
                          </svg>
                          <center>                <p className="mb-2 text-sm text-gray-300 "><span className="font-semibold">{t("Cliquez pour télécharger")}</span> </p>
                          </center>                <p className="text-xs text-gray-400 ">SVG, PNG, JPG or GIF (MAX.
                            800x400px)</p>
                          <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>

                        </div>

                        <input onChange={(e) => { AddingserviceInfoImage(e) }} id="dropzone-file-service" type="file" name='Image' className="hidden" />

                      </label>
                    }
                  </div>


                  {/* <div className="mt-3">
                    <div className="mt-5 ">
                      <input onChange={(e) => AddingserviceInfo(e)} type="text" id="name" name="name" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Entrer le titre de votre service/produit")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span></p>

                    </div>
                  </div> */}
                  <div className="mt-3">
  <div className="mt-5">
    {LanguageSelected === 'fr' && (
      <input 
        onChange={AddingserviceInfo} 
        type="text" 
        name="name-fr" 
        value={serviceInfo.name?.fr || ''}
        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
        placeholder={t("Entrer le titre de votre service/produit")} 
        required 
      />
    )}
    {LanguageSelected === 'en' && (
      <input 
        onChange={AddingserviceInfo} 
        type="text" 
        name="name-en" 
        value={serviceInfo.name?.en || ''}
        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
        placeholder="Enter your service/product title" 
        required 
      />
    )}
    {LanguageSelected === 'ar' && (
      <input 
        onChange={AddingserviceInfo} 
        type="text" 
        name="name-ar" 
        dir="rtl"
        value={serviceInfo.name?.ar || ''}
        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
        placeholder="أدخل عنوان الخدمة/المنتج" 
        required 
      />
    )}
    <p className="mt-2 text-red-600 dark:text-red-500">
      <span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span>
    </p>
  </div>
</div>
                  <div className="mt-3">
                    <div className="mt-5 ">
                      <input onChange={(e) => AddingserviceInfo(e)} type="text" id="link" name="link" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Entrer le lien de votre service/produit")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('link') && InputsErrors.link}</span></p>

                    </div>
                  </div>
                  {/* <div className="mt-5">
                    <textarea onChange={(e) => AddingserviceInfo(e)} id="Description" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" name="description" rows={4} cols={50} placeholder={t("Entrer la description de votre service/produit")} />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span></p>

                  </div> */}
                  <div className="mt-5">
  {LanguageSelected === 'fr' && (
    <textarea 
      onChange={AddingserviceInfo} 
      name="description-fr" 
      value={serviceInfo.description?.fr || ''}
      className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
      rows={4} 
      placeholder={t("Entrer la description de votre service/produit")} 
    />
  )}
  {LanguageSelected === 'en' && (
    <textarea 
      onChange={AddingserviceInfo} 
      name="description-en" 
      value={serviceInfo.description?.en || ''}
      className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
      rows={4} 
      placeholder="Enter your service/product description" 
    />
  )}
  {LanguageSelected === 'ar' && (
    <textarea 
      onChange={AddingserviceInfo} 
      name="description-ar" 
      dir="rtl"
      value={serviceInfo.description?.ar || ''}
      className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
      rows={4} 
      placeholder="أدخل وصف الخدمة/المنتج" 
    />
  )}
  <p className="mt-2 text-red-600 dark:text-red-500">
    <span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span>
  </p>
</div>
                  <div className="grid grid-cols-10 gap-2">
                    <div className="col-span-7 ">
                      <input onChange={(e) => AddingserviceInfo(e)} type="text" id="Price" name="Price" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active mt-3  sm:text-sm" placeholder={t("Entrer le prix de votre service/produit")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Price') && InputsErrors.Price}</span></p>

                    </div>
                    <div className="col-span-3">
                      <select onChange={(e) => AddingserviceInfo(e)} name='currency' className="mt-3.5 block   px-3 py-2 bg-gray-700   rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm w-22   ">
                        <option disabled selected>{t("devise")}</option>

                        <option value='MAD' >MAD</option>
                        <option value='EUR' >EUR</option>
                        <option value='USD' >USD</option>
                      </select>
                    </div>
                  </div>
                </div>
                <button onClick={(e) => StoreServiceInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                  {t("enregistrer")}
                </button>
              </form></div>
          </div>
        </div>




      }



      {FindServiceModal &&

        serviceContent.map(service => {
          if (service.id == FindServiceInfo) {
            return (
              <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                <div className="relative max-h-screen findservice overflow-hidden rounded-xl  sections">
                  <div className="absolute -top-3 -right-3 p-4">
                    <a className='w-12 h-12' onClick={() => { setFindServiceModal(false) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white div-sections opacity-50 rounded-xl cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                      </svg>
                    </a>
                  </div>
                  <div className="text-about -mt-3">
                    <div className='w-full h-56 mx-auto '>
                      <img className="cover w-full h-full preview-image   rounded-t-xl" src={service.image != null ? `${ImageUrl}/${hashedUserId}/${service.image}` : img5} alt="Mountain" />

                    </div>
                    <div className=" px-4 py-4">
                      <div className="font-bold text-2xl leading-none  text-theme title--h5">  {service.name?.[LanguageSelected] || service.name?.fr || ''}</div>
                      <p className="text-theme mt-1 text-about">  {service.description?.[LanguageSelected] || service.description?.fr || ''}</p>
                    </div>
                    <div className='flex justify-between '>

                      <div className="px-4 mb-3 pb-2">

                        {service.price != null &&
                          <p className=' text-theme font-bold text-xl'>{service.price} {service.currency}</p>
                        }
                      </div>

                      <div className="px-4 pb-2">
                        {service.link != null &&
                          <a target='_blank' href={service.link} className='text-theme  text-lg font-bold ' >
                            {t("Voir")} </a>

                        }

                      </div>
                    </div>



                  </div>
                </div>
              </div>
            )
          }
        })


      }


      {EditServicesModal &&
        serviceContent.map(service => {
          if (service.id == serviceId) {
            return (
              <div>
                <div className="minscreen h-full animated fadeIn faster  fixed overflow-auto  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
                  <div className="absolute top-0 right-0 p-4">
                    <a className='w-12 h-12' onClick={() => { setEditServicesModal(false); seteditImage(false); setImageToCrop(null); setCroppedImage(null); setInputsErrors([]) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                      </svg>
                    </a>
                  </div>
                  <div className="w-full max-w-sm  p-8  rounded-md">
                    <h2 className="text-3xl text-theme mt-22 mb-2">{t("Produits et services")}
                    </h2>
                    <form className="space-y-6 text-about">
                      <div>
                        <label htmlFor="image" className="textModal ">{t("Modifier vos informations sur les produits ou services.")} </label>
                        {croppedImage &&
                          <div className='relative'>
                            <div className='w-44 h-44'>
                              <img className="cover w-full h-full preview-image  rounded-xl mt-4" src={URL.createObjectURL(croppedImage)} alt="Preview" />

                            </div>
                            <a onClick={() => { setImageToCrop(null); setCroppedImage(null); }}>
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1  text-white div-sections opacity-50 rounded-xl  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                              </svg>
                            </a>
                            <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('image') && InputsErrors.image}</span></p>

                          </div>
                        }
                        {service.image && !editImage &&
                          <div className='relative'>
                            <div className='w-44 h-44'>
                              <img className="cover w-full h-full preview-image   rounded-xl mt-4" src={`${ImageUrl}/${hashedUserId}/${service.image}`} alt="Preview" />

                            </div>
                            <a onClick={() => { setImageToCrop(null); setCroppedImage(null); seteditImage(true); setServiceInfo({ ...serviceInfo, Image: '_DELETE' }) }}>
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1  text-white div-sections opacity-50 rounded-xl  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                              </svg>
                            </a>
                            <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('image') && InputsErrors.image}</span></p>

                          </div>
                        }


                        <div className="flex items-center justify-center w-full">
                          {!service.image && !croppedImage &&

                            <label htmlFor="dropzone-file-serviceEdit" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections  ">
                              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                                  </path>
                                </svg>
                                <center>                <p className="mb-2 text-sm text-gray-300 "><span className="font-semibold">{t("Cliquez pour télécharger")}</span> </p>
                                </center>                <p className="text-xs text-gray-400 ">SVG, PNG, JPG or GIF (MAX.
                                  800x400px)</p>
                                <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('image') && InputsErrors.image}</span></p>

                              </div>

                              <input onChange={(e) => { AddingserviceInfoImage(e) }} id="dropzone-file-serviceEdit" type="file" name='Image' className="hidden" />

                            </label>
                          }
                          {editImage && !croppedImage &&

                            <label htmlFor="dropzone-file-serviceEdit" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections  ">
                              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                                  </path>
                                </svg>
                                <center>                <p className="mb-2 text-sm text-gray-300 "><span className="font-semibold">{t("Cliquez pour télécharger")}</span> </p>
                                </center>                <p className="text-xs text-gray-400 ">SVG, PNG, JPG or GIF (MAX.
                                  800x400px)</p>
                                <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('image') && InputsErrors.image}</span></p>

                              </div>

                              <input onChange={(e) => { AddingserviceInfoImage(e) }} id="dropzone-file-serviceEdit" type="file" name='Image' className="hidden" />

                            </label>
                          }
                        </div>

                        {/* <div className="mt-3">
                          <div className="mt-5 ">
                            <input defaultValue={service.name} onChange={(e) => AddingserviceInfo(e)} type="text" id="name" name="name" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Entrer le titre de votre service/produit")} required />
                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span></p>

                          </div>
                        </div> */}
                        <div className="mt-3">
  <div className="mt-5">
    {LanguageSelected === 'fr' && (
      <input 
        value={serviceInfo.name?.fr || ''}
        onChange={AddingserviceInfo} 
        type="text" 
        name="name-fr" 
        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
        placeholder={t("Entrer le titre de votre service/produit")} 
        required 
      />
    )}
    {LanguageSelected === 'en' && (
      <input 
        value={serviceInfo.name?.en || ''}
        onChange={AddingserviceInfo} 
        type="text" 
        name="name-en" 
        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
        placeholder="Enter your service/product title" 
        required 
      />
    )}
    {LanguageSelected === 'ar' && (
      <input 
        value={serviceInfo.name?.ar || ''}
        onChange={AddingserviceInfo} 
        type="text" 
        name="name-ar" 
        dir="rtl"
        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
        placeholder="أدخل عنوان الخدمة/المنتج" 
        required 
      />
    )}
    <p className="mt-2 text-red-600 dark:text-red-500">
      <span className="font-xsmall">{InputsErrors.hasOwnProperty('name') && InputsErrors.name}</span>
    </p>
  </div>
</div>
                        <div className="mt-3">
                          <div className="mt-5 ">
                            <input defaultValue={service.link} onChange={(e) => AddingserviceInfo(e)} type="text" id="link" name="link" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Entrer le lien de votre service/produit")} required />
                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('link') && InputsErrors.link}</span></p>

                          </div>
                        </div>
                        {/* <div className="mt-5">
                          <textarea defaultValue={service.description} onChange={(e) => AddingserviceInfo(e)} id="Description" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" name="description" rows={4} cols={50} placeholder={t("Entrer la description de votre service/produit")} />
                          <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span></p>

                        </div> */}
                        <div className="mt-5">
  {LanguageSelected === 'fr' && (
    <textarea 
      value={serviceInfo.description?.fr || ''}
      onChange={AddingserviceInfo} 
      name="description-fr" 
      className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
      rows={4} 
      placeholder={t("Entrer la description de votre service/produit")} 
    />
  )}
  {LanguageSelected === 'en' && (
    <textarea 
      value={serviceInfo.description?.en || ''}
      onChange={AddingserviceInfo} 
      name="description-en" 
      className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
      rows={4} 
      placeholder="Enter your service/product description" 
    />
  )}
  {LanguageSelected === 'ar' && (
    <textarea 
      value={serviceInfo.description?.ar || ''}
      onChange={AddingserviceInfo} 
      name="description-ar" 
      dir="rtl"
      className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded-xl placeholder-gray-111 text-black focus:outline-none active sm:text-sm" 
      rows={4} 
      placeholder="أدخل وصف الخدمة/المنتج" 
    />
  )}
  <p className="mt-2 text-red-600 dark:text-red-500">
    <span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span>
  </p>
</div>
                        <div className="grid grid-cols-10 gap-2">
                          <div className="col-span-7 ">
                            <input defaultValue={service.price} onChange={(e) => AddingserviceInfo(e)} type="number" id="Price" name="Price" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active mt-3  sm:text-sm" placeholder={t("Entrer le prix de votre service/produit")} required />
                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Price') && InputsErrors.Price}</span></p>

                          </div>
                          <div className="col-span-3">
                            <select name='currency' onChange={(e) => AddingserviceInfo(e)} value={serviceInfo.currency || 'MAD'} className="mt-3.5 block   px-3 py-2 bg-gray-700   rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm w-22   ">
                              {/* <option disabled selected>{t("devise")}</option> */}

                              <option value='MAD' >MAD</option>
                              <option value='EUR' >EUR</option>
                              <option value='USD' >USD</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <button onClick={(e) => UpdateServiceInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                        {t("enregistrer")}
                      </button>
                    </form></div>
                </div>
              </div>
            )
          }
        })



      }


      {CropImage &&
        <div>
          <div className="minscreen overflow-auto h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-1000 forms-info">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setCropImage(false); setCroppedImage(null);
                setImageToCrop(null);
                setZoom(1)

              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full text-about settingswidth p-8">
              <div className="flex flex-col items-left justify-start mt-8">
                <p className="text-md text-gold ">
                  {t("Recadrez votre photo pour un meilleur rendu")}
                </p>
              </div>


              <div className='flex flex-col items-center justify-center p-6'>
                {imageToCrop && (
                  <div className=" crop-container w-full ">
                    <Cropper
                      image={imageToCrop}
                      crop={crop}
                      zoom={zoom}
                      aspect={4 / 4}
                      onCropChange={onCropChange}
                      onZoomChange={onZoomChange}
                      onCropComplete={handleCropComplete}
                    />
                  </div>
                )}
                <div className=" controls">
                  <label for="zoom-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zoom : </label>
                  <input id="zoom-input" type="range"
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e) => onZoomChange(parseFloat(e.target.value))}
                    className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none cursor-pointer text-gold" />

                </div>
                {croppedImage && (
                  <div className=" cropped-image-container">
                    <div className="flex flex-col items-left justify-start mt-2 mb-4">
                      <p className="text-md text-gold ">
                        {t("Image Recadrer")}
                      </p>
                    </div>
                    <div className='crop-image'>
                      <img src={URL.createObjectURL(croppedImage)} alt="Cropped" />

                    </div>
                  </div>
                )}
              </div>



              <div>
                <button
                  onClick={(e) => { setCropImage(false); Base64Image() }}
                  type="submit"
                  className="w-full btn-edit"
                >
                  {t("enregistrer")}
                </button>
              </div>
            </div>
          </div>
        </div>

      }

    </div>
  )
}

export default ServicesEdit